import { type PropsWithChildren } from "react";

import { customTv } from "#utils";

import type { VariantProps } from "tailwind-variants";

const paperStyles = customTv({
  base: "bg-background-primary p-xl",
  variants: {
    variant: {
      "card-like": "rounded-sm border-2 border-background-secondary",
      pure: "",
    },
  },
  defaultVariants: {
    variant: "card-like",
  },
});

export interface PaperProps extends PropsWithChildren, VariantProps<typeof paperStyles> {
  className?: string;
}

export function Paper({ variant = "card-like", className, children }: PaperProps) {
  return <article className={paperStyles({ variant, class: className })}>{children}</article>;
}
